import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AppModule} from './app.module';

import {APIUrl} from './constants';
import {ImagesServiceUrl} from './constants';

@Injectable({
  providedIn: 'root'
})
export class B2BService {

  readonly APIUrl = APIUrl;
  readonly ImagesServiceUrl = ImagesServiceUrl;

  constructor(private http:HttpClient) { }

  GetB2BRelevantAgents(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Relevant/Agents', val)
  }

  SwitchGridProductOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Switch/Grid/Product/Offer', val)
  }

  GetIndustryProductByStockOverRequestedQuantity(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Industry/Product/By/StockOverRequested/Quantity', val)
  }

  GetIndustryProductCalculatedSideOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Industry/Product/Calculated/SideOffers', val)
  }

  GetIndustryProductCalculatedSideOffersWithCollateral(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Industry/Product/Calculated/SideOffers/With/Collateral', val)
  }
  
  SwitchGridResultProduct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Switch/Grid/Result/Product', val)
  }

  ChangeGridQuantityVersion2(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Change/Grid/Quantity/Version2', val)
  }

  SearchIndustryProductNameAndPartNumberParrallelB2BBrandsVersion2(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Search/Industry/Product/Name/And/PartNumber/Parrallel/B2B/Brands/Version2', val)
  }

  AdjustOrderDeliveryPreference(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Adjust/Order/Delivery/Preference', val)
  }

  SearchIndustryProductB2BBrandsVersion2(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Search/Industry/Product/B2B/Brands/Version2', val)
  }

  SwitchGridBrandVersion2(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Switch/Grid/Brand/Version2', val)
  }

  SearchIndustryProductB2BOffersVersion2(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Search/Industry/Product/B2B/Offers/Version2', val)
  }

  GetB2BUserConnectedPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/User/Connected/Partner', val)
  }

  AddUpdateB2BUserPartnerConnection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Add/Update/B2B/User/Partner/Connection', val)
  }

  AddUpdateB2BUserAgentConnection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Add/Update/B2B/User/Agent/Connection', val)
  }

  DeallocateB2BUserAgentConnection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Deallocate/B2BUser/Agent/Connection', val)
  }

  GetB2BUserConnectedAgent(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/User/Connected/Agent', val)
  }

  GetGridCellItemDataWithDBLevelCalculation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Grid/Cell/Item/Data/With/DBLevel/Calculation', val)
  }

  GetGridCellItemData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Grid/Cell/Item/Data', val)
  }

  GetB2BMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Master/Data', val)
  }

  InitializeCartItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Initialize/Cart/Item', val)
  }

  AddPartnerShippingAddressChangeRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Add/Partner/Shipping/Address/Change/Request', val)
  }

  GetPartnerShippingAddressChangeRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Partner/Shipping/Address/Change/Request', val)
  }

  InitializeCart(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Initialize/Cart', val)
  }

  ProofUserB2BData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Proof/User/B2B/Data', val)
  }

  PopulateCartItems(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Populate/Cart/Items', val)
  }

  ChangeGridCellItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Change/Grid/Cell/Item', val)
  }

  ExportB2BGrid(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Export/B2B/Grid', val)
  }

  SearchIndustryProductsFromGridCell(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Search/Industry/Products/From/Grid/Cell', val)
  }

  SplitGetIndustryProductsSearchQuery(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Split/Get/Industry/Products/Search/Query', val)
  }

  GetB2BInvoices(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Invoices', val)
  }

  GetInvoicesFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Invoices/COUNT', val)
  }

  GetOrdersMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Orders/Get/Orders/Master/Data', val)
  }

  GetProductLeadTime(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Orders/Get/Product/Lead/Time', val)
  }

  ChangeOfferRequestStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Change/Offer/Request/Status', val)
  }

  AddNewOfferRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Add/New/Offer/Request', val)
  }

  DownloadOfficialOfferPDF(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Download/Official/OfferPDF', val)
  }

  GetOfferRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Request', val)
  }

  GetOfferRequestLogs(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Request/Logs', val)
  }

  GetOfferRequestItems(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Request/Items', val)
  }

  GetOfferRequestMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Request/Master/Data', val)
  }

  GetOfferRequestsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Requests/Filtered', val)
  }

  GetOfferRequestsFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Requests/Filtered/COUNT', val)
  }

  CancelOfferRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Cancel/Offer/Request', val)
  }

  ExportOfferRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Export/Offer/Request', val)
  }

  AcceptNewlyQuotedPrices(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Accept/Newly/Quoted/Prices', val)
  }

  PreCheckOfferRequestConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Pre/Check/Offer/Request/Confirmation', val)
  }

  GetB2BHomePageMessage(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Home/Page/Message', val)
  }

  GetUserManagerUnreadOfferRequests(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/User/Manager/Unread/Offer/Requests', val)
  }

  GetB2BPartnerRelatedCompanies(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Partner/Related/Companies', val)
  }
  
  GetB2BListedBrands(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Listed/Brands', val)
  }

  GetB2BClientOrders(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Client/Orders', val)
  }

  GetClientOCDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/Client/OC/Details', val)
  }

  GetB2BUserClients(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/User/Clients', val)
  }

  PrepareGridCellItemSideOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Prepare/Grid/Cell/Item/Side/Offers', val)
  }

  GetB2BClientOCReadyItemsUX(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Get/B2B/Client/OCReady/Items', val)
  }

  SendDispatchEmailClientRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Send/Dispatch/Email/Client/Request', val)
  }

  CheckExceedingStocks(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Check/Exceeding/Stocks', val)
  }

  SendClientRequestToPendingOrderConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Send/Client/Request/To/Pending/Order/Confirmation', val)
  }
}
